// extracted by mini-css-extract-plugin
export default {"bottom":"CopyrightFooter_bottom__2CAjF","copyright":"CopyrightFooter_copyright__V7k0Z","socials":"CopyrightFooter_socials__xCoZk","social":"CopyrightFooter_social__OMrU8"};